import React, { useEffect, useState } from 'react';
import { format } from '../../App'
import { useParams } from 'react-router-dom/';
import { Alert } from 'antd';
import moment from 'moment'
import QRCodeReact from 'qrcode.react'
const ip = process.env.REACT_APP_IP
export default function Show() {
    let { no } = useParams()
    const [oneData, setoneData] = useState({})
    function getOnePolicy(no) {
        let link = `${ip}sell_online/QrCode/${no}`
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        fetch(link, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.data.status === 200) {
                    setoneData(result.data.data)
                } else {
                    setoneData({})
                }
            })
            .catch(error => console.log('error', error));
    }
    useEffect(() => {
        if (no) {
            getOnePolicy(no)
        }
    }, [no])
    return (
        <div className="container">

            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            backgroundImage: 'linear-gradient(to left, #003c3c , #248b6f)',
                            marginBottom: 10
                        }}
                    >
                        <div style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex',
                            backgroundColor: '#fff',
                            paddingLeft: 20, paddingRight: 20
                        }}>
                            <img src="../images/full.png" width='150' alt='logo' />
                        </div>
                        <div style={{
                            paddingTop: 12,
                            flex: 1
                        }}>
                            <h4 style={{ color: '#fff', paddingLeft: 10 }}>ລາຍລະອຽດສັນຍາປະກັນໄພ </h4>
                        </div>

                    </div>
                    {oneData.length > 0 ?
                        <>
                            <table className='table table-sm table-striped table-bordered table-hover' >
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>ຫົວຂໍ້</th>
                                        <th >ລາຍລະອຽດ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {oneData.map((d, i) => {
                                        return (
                                            <>
                                                <tr key={i}>
                                                    <td>1</td>
                                                    <td >ເລກທີສັນຍາ</td>
                                                    <td> {d.no}</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ປ້າຍເລກທະບຽນ</td>
                                                    <td>{
                                                        d.o_plate
                                                        // substg(d.Plate_No)
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td >ຜູ້ໃດ້ຮັບການປະກັນໄພ</td>
                                                    <td>{d.o_name}</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ເລກຈັກ</td>
                                                    <td>{(d.o_engine)}</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>ເລກຖັງ</td>
                                                    <td>{(d.o_chassis)}</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>ຄ່າທຳນຽມປະກັນໄພ</td>
                                                    <td>{format(d.total_premuim)}</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>ປະເພດການຄຸ້ມກັນ</td>
                                                    <td>{d.cover}</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>ວັນສິ້ນສຸດການຄຸ້ມກັນ</td>
                                                    <td>

                                                        {
                                                            moment(new Date()).format('YYYY/MM/DD') > moment(d.end).format('YYYY/MM/DD') ?
                                                                <p className='text-danger'> ສັນຍາໝົດອາຍຸ {moment(d.end).format('DD/MM/YYYY h:mm:ss')}</p>
                                                                :
                                                                <p className='text-info' >  {moment(d.end).format('DD/MM/YYYY h:mm:ss')}</p>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>ຊື້ຈາກຕົວແທນຈຳໜ່າຍ</td>
                                                    <td>{d.userText}</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>ສະຖານະຂອງສັນຍາ</td>
                                                    <td>
                                                        {
                                                            d.cancel === 0 ?
                                                                <p className='text-info'>  ສັນຍາບໍ່ຖືກຍົກເລີກ </p>
                                                                :
                                                                <p className='text-danger'>  ສັນຍາຖືກຍົກເລີກ</p>
                                                        }
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </table>
                            <QRCodeReact value={window.location.href} />
                        </>
                        :
                        alertPolicyNotfound(no)
                    }
                </div>
            </div>
        </div>
    )
}
function alertPolicyNotfound(policy) {
    return (
        <Alert
            message="ແຈ້ງເຕືອນ"
            description={`ສັນຍາເລກທີ  ${policy}  ບໍ່ມີໃນລະບົບ`}
            type="error"
            showIcon
        />
    )

}